var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 2C0.5 1.30964 1.05964 0.75 1.75 0.75H16.25C16.9404 0.75 17.5 1.30964 17.5 2C17.5 2.69036 16.9404 3.25 16.25 3.25H1.75C1.05964 3.25 0.5 2.69036 0.5 2ZM3.5 7C3.5 6.30964 4.05964 5.75 4.75 5.75H16.25C16.9404 5.75 17.5 6.30964 17.5 7C17.5 7.69036 16.9404 8.25 16.25 8.25H4.75C4.05964 8.25 3.5 7.69036 3.5 7ZM7.75 10.75C7.05964 10.75 6.5 11.3096 6.5 12C6.5 12.6904 7.05964 13.25 7.75 13.25H16.25C16.9404 13.25 17.5 12.6904 17.5 12C17.5 11.3096 16.9404 10.75 16.25 10.75H7.75Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.3b8be3f22c008aa486784783aea6ba1c.svg";
export { ForwardRef as ReactComponent };